/** @format */

import React, { useState, useEffect } from "react";
import {
  getProductMainImage,
  getVendorSettings,
  setVendorData,
  getGlobalSettings,
} from "../../services/helper";
import { FiSettings, FiX, FiPlus } from "react-icons/fi";
import POSModal from "./POSItemsQuickEditModal";
import http from "../../services/http";
import { useSelector, useDispatch } from "react-redux";
import { setPosItems } from "../../ReduxToolkit/Reducers/CartReducer";
import { getCurrentUser } from "../../services/auth";

export default function POSItem({
  products,
  searchQuery,
  onProductClick,
  onUpdateProduct,
}) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  // const { posItems } = useSelector((state) => state.cart);
  const [posItems, setPosItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [showProductSelector, setShowProductSelector] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const dispatch = useDispatch();
  const user_data = getCurrentUser();

  useEffect(() => {
    const savedItems = user_data?.global_settings?.pos_items;

    if (savedItems) {
      try {
        const parsedItems = JSON.parse(savedItems);
        // if (Array.isArray(parsedItems)) {
        //   const validItems = parsedItems.filter(
        //     (item) => item && products.some((p) => p.id === item.id)
        //   );

        setPosItems(parsedItems);
      } catch (error) {
        console.error("Failed to parse POS items:", error);
        setPosItems([]);
      }
    } else {
      setPosItems([]);
    }
  }, [products]);

  const filteredProducts = products.filter((product) => {
    const lowerCaseQuery = searchQuery.toLowerCase().trim();
    if (!lowerCaseQuery) return true;

    const terms = lowerCaseQuery.split(" ");
    const name = product.name?.toLowerCase() || "";
    const sku = product.sku?.toLowerCase() || "";

    return terms.every((term) => name.includes(term) || sku.includes(term));
  });

  const savePOSItems = async (items) => {
    try {
      const pos_items = JSON.stringify(items);
      localStorage.setItem("pos_items", pos_items);
      dispatch(setPosItems(items));
    } catch (e) {
      console.error("Error saving POS items:", e);
    }
  };

  const handleOpenModal = (product) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  const handleSelectPOSProduct = (product) => {
    if (!posItems.find((item) => item.id === product.id)) {
      savePOSItems([...posItems, product]);
    }
    setShowProductSelector(false);
  };

  const handleRemovePOSProduct = (productId) => {
    savePOSItems(posItems.filter((item) => item.id !== productId));
  };

  const handleSave = () => {
    const updatedItems = posItems.map((item) =>
      item.id === selectedProduct.id ? selectedProduct : item
    );

    onUpdateProduct && onUpdateProduct(selectedProduct);
    savePOSItems(updatedItems);
    setModalOpen(false);
    setSelectedProduct(null);
  };

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDrop = (index) => {
    if (draggedIndex === null || draggedIndex === index) return;

    const updatedItems = [...posItems];
    const [draggedItem] = updatedItems.splice(draggedIndex, 1);
    updatedItems.splice(index, 0, draggedItem);
    savePOSItems(updatedItems);
    setDraggedIndex(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // Required to allow dropping
  };

  return (
    <>
      <div className="product-tiles mt-2 d-flex flex-wrap gap-2">
        {(searchQuery.trim() ? filteredProducts : posItems || []).map(
          (product, index) => (
            <div
              key={product.id}
              role="button"
              draggable={true}
              onClick={() => onProductClick(product)}
              onDragStart={() => handleDragStart(index)}
              onDragOver={handleDragOver}
              onDrop={() => handleDrop(index)}
              style={{
                position: "relative",
                width: "120px",
                height: "140px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "8px",
                backgroundColor: "#fff",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.transform = "scale(1.02)")}
              onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
              {/* Header Area */}
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  right: "0",
                  height: "24px",
                  backgroundColor: "rgba(0,0,0,0.7)",
                  borderRadius: "8px 8px 0 0",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0 6px",
                  zIndex: 2,
                }}
              >
                <FiX
                  size={14}
                  style={{ color: "#fff", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemovePOSProduct(product.id);
                  }}
                />

                {product.shortcut_key && (
                  <span
                    style={{
                      fontSize: "10px",
                      color: "#000",
                      fontWeight: "bold",
                      backgroundColor: "#ffc107",
                      padding: "1px 4px",
                      borderRadius: "2px",
                    }}
                  >
                    {product.shortcut_key}
                  </span>
                )}

                <FiSettings
                  size={14}
                  style={{ color: "#fff", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenModal(product);
                  }}
                />
              </div>

              {/* Product Image */}
              <img
                src={getProductMainImage(product)}
                alt={product.name}
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  marginTop: "28px",
                }}
              />

              {/* Product Details */}
              <div
                style={{ textAlign: "center", width: "100%", marginTop: "2px" }}
              >
                <p
                  style={{
                    fontSize: "11px",
                    fontWeight: "500",
                    margin: "0",
                    lineHeight: "1.2",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                  }}
                >
                  {product.name}
                </p>
              </div>
            </div>
          )
        )}
      </div>

      <POSModal
        isOpen={modalOpen || showProductSelector}
        toggle={() => {
          setModalOpen(false);
          setShowProductSelector(false);
          setSelectedProduct(null);
        }}
        products={products}
        handleSelectPOSProduct={handleSelectPOSProduct}
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        handleSave={handleSave}
      />
    </>
  );
}
